import moment from "moment";

export const nextWorkingDay = () => {
  let today = moment();
  switch (today.isoWeekday()) {
    case 5: //friday
      return today.add(3, "day");
    case 6: //saturday
      return today.add(2, "day");
    default:
      return today.add(1, "day");
  }
}

export function isUnderTwentyOne(birthDate: string | undefined, ssn: string | undefined) {
  let years;
  if (birthDate && moment(birthDate, 'DDMMYYYY').isValid()) {
    years = moment().diff(moment(birthDate, 'DDMMYYYY'), 'years');
  } else if (ssn && ssn.length === 11) {
    // calculate age years
    if (ssn.substring(6, 7) === 'A') {
      years = moment().diff('20' + ssn.substring(4, 6) + '-' + ssn.substring(2, 4) + '-' + ssn.substring(0, 2), 'years');
    } else {
      years = moment().diff('19' + ssn.substring(4, 6) + '-' + ssn.substring(2, 4) + '-' + ssn.substring(0, 2), 'years');
    }
  } else {
    years = 18;
  }

  return years < 21;
}

export function weekDay(d: any) {
  if (moment.isMoment(d)) {
    return d.clone().format('dddd');
  }
  return ''
}

export function cx(...classes: string[]) { //apply styles
  let s = '';
  for (const a of classes)
    if(a)
      s += ` ${a}`
  return s;
}

export const priceFormat = (number: number) => {
  return new Intl.NumberFormat(`fi-Fi`, {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: "code"
  })
    .formatToParts(number)
    .filter(x => x.type !== "currency")
    .map(x => x.value)
    .join("")
    .trim()
}